import { useNavigate, useRouteError } from 'react-router-dom'
import { useDI } from '@/di/DIContext'
import { PageFull } from '@/presentation/components/PageFull'

/**
 * 路由全局错误边界组件
 * 捕获 Loader 抛出的异常或渲染阶段的崩溃
 */
export function RouteErrorBoundary() {
  const error = useRouteError() as any
  const navigate = useNavigate()
  const { sessionService } = useDI()

  // 提取错误信息
  const errorMessage =
    error?.statusText ||
    error?.message ||
    (typeof error === 'string' ? error : 'Unknown Application Error')

  const handleRetry = () => {
    window.location.reload()
  }

  const handleBackToLogin = () => {
    sessionService.clearSession()
    navigate('/login', { replace: true })
  }

  return (
    <PageFull
      className='flex flex-col items-center justify-center bg-white px-[32px] text-center'
      data-testid='route-error-boundary'
    >
      <div className='flex flex-col items-center gap-[24px] max-w-[320px]'>
        {/* 视觉图标：使用一个带有设计感的感叹号或错误插图 */}
        <div className='flex size-[80px] items-center justify-center rounded-full bg-[#FFF1F0] text-[#FF4D4F]'>
          <svg
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
            className='size-[40px]'
          >
            <circle cx='12' cy='12' r='10' />
            <line x1='12' y1='8' x2='12' y2='12' />
            <line x1='12' y1='16' x2='12.01' y2='16' />
          </svg>
        </div>

        <div className='flex flex-col gap-[8px]'>
          <h1 className='text-[20px] font-bold text-[#1a1a1a]'>
            Oops! Something went wrong
          </h1>
          <p className='text-[14px] leading-[20px] text-[#5e676d]'>
            {errorMessage}
          </p>
        </div>

        <div className='flex w-full flex-col gap-[12px] mt-[12px]'>
          <button
            type='button'
            onClick={handleRetry}
            className='h-[48px] w-full rounded-[24px] bg-[#6C5CE7] text-[16px] font-semibold text-white shadow-[0_4px_10px_rgba(108,92,231,0.2)] active:scale-95 transition-all'
            data-testid='error-retry-btn'
          >
            Try Again
          </button>

          <button
            type='button'
            onClick={handleBackToLogin}
            className='text-[14px] font-medium text-[#5e676d] hover:text-[#1a1a1a] transition-colors'
            data-testid='error-login-btn'
          >
            Back to Login
          </button>
        </div>
      </div>
    </PageFull>
  )
}
